import { parsePhoneNumber } from "libphonenumber-js";
import { getMyInvoisRequiredFields } from "../../containers/AppPage/ControlPanel/Profile/getMyInvoisRequiredFields";
import actions from "./actions";

let company, addresses, idx;

const initState = {
    createState: null,
    createResult: null,
    companyResetState: null,

    companyReadState: false,
    myInvoisReadyReadState: false,
    companyReadListState: false,
    companyUpdateState: false,
    companyUpdateResult: {},
    company: {},
    companies: [], // Used at Logo and Billing & Subscription event log page
    addresses: [],
    initialNum: 0,
    copyBillingAddress: false,
    msicCode: null,
    msicCodeReadState: false,
    msicCodePatchState: false,
    isMyInvoisReady: null,
    myInvoisReadyInvalidFields: [],
    prevIsMyInvoisReady: null,
    isMyInvoisValidated: null,

    myInvoisFields: {},
    myInvoisAddressFields: {},
};

function generateKey() {
    return Math.random().toString(36);
}

function getMyInvoisFieldsOnReadSuccess(company) {
    const requiredValues = [...getMyInvoisRequiredFields('profile'), ...getMyInvoisRequiredFields('contact')];

    const obj = requiredValues.reduce((acc, key) => ({ ...acc, [key]: company[key] }), {});

    // parse phone number
    let countryCallingCode, nationalNumber;
    if (company.phone_no) {
        const firstPhoneNum = company.phone_no.split(",")[0];
        try {
            ({countryCallingCode, nationalNumber} = parsePhoneNumber(`+${firstPhoneNum}`));
        }
        catch (err) {
            //
        }
    }

    if (nationalNumber)
        obj.phone_no = nationalNumber;
    if (countryCallingCode)
        obj.phone_no_code = countryCallingCode;

    return obj;
}

function getMyInvoisAddressFieldsOnReadSuccess(company) {
    const requiredValues = [...getMyInvoisRequiredFields('address')];

    const defaultBillingAddress = company?.addresses?.find(add => add.is_default_billing);

    if (!defaultBillingAddress)
        return {address: false};

    return requiredValues.reduce((acc, key) => ({ ...acc, [key]: defaultBillingAddress[key] }), {});
}

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.COMPANY_CREATE_REQUEST:
            return {
                ...state,
                createState: 'request',
            };
        case actions.COMPANY_CREATE_SUCCESS:
            return {
                ...state,
                createState: 'success',
                createResult: action.data,
            };
        case actions.READ_COMPANY_REQUEST:
            return {
                ...state,
                companyReadState: 'request',
            };
        case actions.READ_COMPANY_SUCCESS:
            return {
                ...state,
                companyReadState: 'success',
                company: action.company,
                addresses: action.company?.addresses.map(address => {
                    const newAddress = {...address};
                    if (!address.key)
                        newAddress.key = generateKey();
                    return newAddress;
                }),
                initialNum: action.company?.addresses.length,
                copyBillingAddress: action.company.copy_billing_address,
                // this is the 5 digit msic code that is fetched from the company profile, check the saga file beside
                msicCode: action.company.msic_code,

                myInvoisFields: getMyInvoisFieldsOnReadSuccess(action.company),
                myInvoisAddressFields: getMyInvoisAddressFieldsOnReadSuccess(action.company),
            };
        case actions.READ_MY_INVOIS_READY_REQUEST:
            return {
                ...state,
                myInvoisReadyReadState: 'request',
            };
        case actions.READ_MY_INVOIS_READY_SUCCESS:
            return {
                ...state,
                myInvoisReadyReadState: 'success',
                isMyInvoisReady: action.isMyInvoisReady,
                myInvoisReadyInvalidFields: action.myInvoisReadyInvalidFields,
                isMyInvoisValidated: !action.myInvoisReadyInvalidFields?.includes('is_myinvois_validated'),
            };
        case actions.READ_COMPANY_LIST_REQUEST:
            return {
                ...state,
                companyReadListState: 'request',
            };
        case actions.READ_COMPANY_LIST_SUCCESS:
            return {
                ...state,
                companyReadListState: 'success',
                companies: action.companies,
            };
        case actions.UPDATE_COMPANY_REQUEST:
            return {
                ...state,
                companyUpdateState: 'request',
            };
        case actions.UPDATE_COMPANY_SUCCESS:
            return {
                ...state,
                companyUpdateState: 'success',
                companyUpdateResult: action.company,
                addresses: state.addresses.map(address => {
                    // newly added address when update company,
                    // change it to the returned object with id, while preserving the order (not alphabetical)
                    if (!address.id) {
                        const returnedAddresses = action.company?.addresses;
                        const returnedAddress = returnedAddresses
                            .find(add => add.name === address.name && add.street === address.street);

                        return {
                            ...address,
                            ...returnedAddress,
                        };
                    }
                    return address;
                }),
                prevIsMyInvoisReady: state.isMyInvoisReady,
            };
        case actions.RESET_PREV_IS_MY_INVOIS_READY:
            return {
                ...state,
                prevIsMyInvoisReady: null,
            };
        case actions.SET_PREV_AND_CURRENT_IS_MY_INVOIS_READY:
            return {
                ...state,
                prevIsMyInvoisReady: action.prevIsMyInvoisReady,
                isMyInvoisReady: action.isMyInvoisReady,
            };
        case actions.PATCH_MSIC_CODE_REQUEST:
            return {
                ...state,
                msicCodePatchState: 'request',
            };
        case actions.PATCH_MSIC_CODE_SUCCESS:
            return {
                ...state,
                msicCodePatchState: 'success',
                msicCode: action.msicCode,
            };
        case actions.PATCH_MSIC_CODE_ERROR:
            return {
                ...state,
                msicCodePatchState: 'error',
            };
        case actions.CHANGE_COMPANY: // Partial update
            company = {
                ...(action.reset ? initState.company : state.company),
                ...action.request,
            };

            return {
                ...state,
                company,
                copyBillingAddress: company.copy_billing_address,
            };
        case actions.CHANGE_COPY_BILLING_ADDRESS:
            return {
                ...state,
                copyBillingAddress: action.copyBillingAddress,
            };
        case actions.COMPANY_RESET_REQUEST:
            return {
                ...state,
                companyResetState: 'request',
            };
        case actions.COMPANY_RESET_SUCCESS:
            return {
                ...state,
                companyResetState: 'success',
            };
        case actions.COMPANY_RESET_ERROR:
            return {
                ...state,
                companyResetState: 'error',
            };
        case actions.SET_ALL_COMPANY_ADDRESSES:
            return {
                ...state,
                addresses: [...action.addresses],
            };

        case actions.ADD_COMPANY_ADDRESS:
            return {
                ...state,
                initialNum: state.initialNum + 1,
                addresses: [
                    ...state.addresses,
                    { key: generateKey(), name: `Address ${state.initialNum + 1}` },
                ],
            };
        case actions.DELETE_COMPANY_ADDRESS:
            addresses = [...state.addresses];
            idx = addresses.findIndex(address => address.key === action.key);
            addresses.splice(idx, 1);
            return {
                ...state,
                addresses,
            };

        case actions.SET_MY_INVOIS_FIELD:
            return {
                ...state,
                myInvoisFields: {
                    ...state.myInvoisFields,
                    [action.key]: action.isMyInvoisFieldValid,
                },
            };
        case actions.SET_MY_INVOIS_ADDRESS_FIELD: // for default billing address
            return {
                ...state,
                myInvoisAddressFields: {
                    ...state.myInvoisAddressFields,
                    address: true, // since now we already have a default billing address, set 'address' to true
                    [action.key]: action.value,
                },
            };
        case actions.RESET_MY_INVOIS_ADDRESS_FIELDS: // for default billing address
            return {
                ...state,
                myInvoisAddressFields: {
                    // wipe all other fields (name, street etc.)
                    address: action.hasDefaultAddress,
                    ...action.values,
                },
            };
        default:
            return state;
    }
}
